import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { LangProvider } from "@/context/LangContext";
import { AuthProvider } from "@/context/AuthContext";
import { PagesProvider } from "@/context/PagesContext";

import PublicLayout from "@/components/PublicLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import PageGuard from "@/components/PageGuard";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import IIEAS from "@/pages/IIEAS";
import Synapse from "@/pages/Synapse";
import Contact from "@/pages/Contact";
import Insights from "@/pages/Insights";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <LangProvider>
      <PagesProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/quienes-somos" element={<PublicLayout><PageGuard pageKey="about"><About /></PageGuard></PublicLayout>} />
              <Route path="/servicios" element={<PublicLayout><PageGuard pageKey="services"><Services /></PageGuard></PublicLayout>} />
              <Route path="/iieas" element={<PublicLayout><PageGuard pageKey="iieas"><IIEAS /></PageGuard></PublicLayout>} />
              <Route path="/synapse" element={<PublicLayout><PageGuard pageKey="synapse"><Synapse /></PageGuard></PublicLayout>} />
              <Route path="/insights" element={<PublicLayout><PageGuard pageKey="insights"><Insights /></PageGuard></PublicLayout>} />
              <Route path="/contacto" element={<PublicLayout><PageGuard pageKey="contact"><Contact /></PageGuard></PublicLayout>} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
            <Toaster />
          </BrowserRouter>
        </AuthProvider>
      </PagesProvider>
    </LangProvider>
  );
}

export default App;
